export const filterForDataQuality = ({state}, item, userGuid) => {
  return (
    (!state.selectedTag || item.tags.some(tag => tag.tagGuid === state.selectedTag.tagGuid)) &&
    (!state.selectedOrigin || item.origins.some(origin => origin.originGuid === state.selectedOrigin.originGuid)) &&
    (!state.searchValue || item.entityName.toLowerCase().includes(state.searchValue.toLowerCase())) &&
    (
      state.currentView.value === 'all'
        ? true
        : state.currentView.value === 'assigned'
          ? item.tags.some(tag =>
            (tag.owners?.includes(userGuid)) ||
              (tag.stewards?.includes(userGuid)) ||
              (tag.governors?.includes(userGuid)),
          )
          : item.tags.some(tag => tag[state.currentView.value]?.includes(userGuid))
    )
  );
};